import './Pagehead-0744ffce.css';

var classes = {"Pagehead":"prc-Pagehead-Pagehead-Dyaie"};

export { classes as default };
